// @flow
import React, { Fragment } from 'react';
import { Section } from '@finect/tabular-components/Section';
import { Service } from './Service';

type Props = {
  onProfileFollow: Function,
  profileSubscriptions: Array<string>,
  services: Array<Object>,
  onRefuseOrganization: Function
};

export class Services extends React.Component<Props> {
  render() {
    const { services } = this.props;

    // let servicesShow = services.filter(service => new Date().getTime() -
    // Date.parse(service.creationDate) < 2629750000);
    let servicesShow = services.filter(service => new Date().getTime() - Date.parse(service.creationDate));
    servicesShow = servicesShow.filter(service => service.session.application === 'advisers-leads');
    if (!servicesShow.length) {
      return null;
    }
    return (
      <Fragment>
        <a id="advisers"></a>
        {servicesShow.length !== 0 ? (
          <Section title={`Expertos financieros con los que has contactado`} bottomMargin>
            {servicesShow.slice(0, 1).map((item, index) => (
              <Service
                key={index}
                index={index}
                service={item}
                onProfileFollow={this.props.onProfileFollow}
                profileSubscriptions={this.props.profileSubscriptions}
                onRefuse={this.props.onRefuseOrganization}
              />
            ))}
          </Section>
        ) : null}
      </Fragment>
    );
  }
}
